import { useContext, createContext, useEffect, useState } from "react";
import {
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
import { authentication, db } from "../firebase-config";
import {
  collection,
  doc,
  query,
  where,
  getDocs,
  setDoc,
} from "firebase/firestore";

/****create an authentication context*/
const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  /***state management of the user*/
  const [user, setUser] = useState({});

  const provider = new GoogleAuthProvider();
  /***Login method***/
  const googleSignIn = async () => {
    try {
      //sign in popup
      const res = await signInWithPopup(authentication, provider);
      //get user info after signing in
      const user = res.user;

      localStorage.setItem("user", JSON.stringify(user.providerData));

      //query that checks if there's a user with the same uid in the database
      const q = query(collection(db, "users"), where("uid", "==", user.uid));
      // gets the docs that match the query
      const docs = await getDocs(q);
      //selecting which collection we using
      const userRef = collection(db, "users");

      var Namearray = [];
      for (let i = 1; i < user.displayName.length + 1; i++) {
        Namearray.push(user.displayName.substring(0, i).toLowerCase());
      }

      //if there's no existing user with the current uid, set a new doc
      if (docs.docs.length === 0) {
        await setDoc(doc(userRef, user.uid), {
          email: user.email,
          profilePic: user.photoURL,
          username: user.displayName.toLowerCase(),
          dateRegister: new Date(),
          uid: user.uid,
          NameAsArray: Namearray,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  /***Logout method***/
  const logOut = () => {
    signOut(authentication);
  };

  /***identifying the user***/
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(authentication, (currentUser) => {
      setUser(currentUser);
    });
    return () => {
      unsubscribe();
    };
  }, []);

  /***returning the component in which the child components will have access to the googleSignIn,logOut methods***/
  return (
    <AuthContext.Provider value={{ googleSignIn, logOut, user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const UserAuth = () => {
  return useContext(AuthContext);
};
